import { Actions } from './actions';
import { CHANGE_ACTIVE_INPUT, SET_STATUSID_TRIP } from './constants';

const initialState = {
  activeInput: '' as string,
  statusId: 0 as number,
};

export type KioskState = typeof initialState;

export const kioskReducer = (state: KioskState = initialState, action: Actions) => {
  switch (action.type) {
    case CHANGE_ACTIVE_INPUT: {
      return {
        ...state,
        activeInput: action.payload,
      };
    }
    case SET_STATUSID_TRIP: {
      return {
        ...state,
        statusId: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
